import moment from "moment";
import { store } from "src/redux/store";

const hasPermission = (allPermissions, permissions, role) => {
  return role === "company"
    ? permissions?.some((perm) => allPermissions?.includes(perm))
    : true;
};

const _nav = (userDetails = {}, permissions) => {
  console.log(permissions, "permissions");

  const { role, _id, is_lead } = userDetails;

  const hidden = role !== "super_admin" && _id !== "665a932fcf5ae6ce8797c7c5";

  return [
    {
      _tag: "CSidebarNavItem",
      name: "Dashboard",
      className: "font-weight-bold ",
      to: "/dashboard",
      icon: "cil-gauge",
      showTo: ["super_admin", "partner", "therapist", "operation", "sales"],
      show: hasPermission(permissions, ["dashboard"], role),
    },
    {
      _tag: "CSidebarNavDropdown",
      name: "User Management",
      className: "font-weight-bold",
      icon: "cil-user-follow",
      showTo: ["super_admin"],
      _children: [
        {
          _tag: "CSidebarNavDropdown",
          name: "Companies",
          className: "font-weight-bold",
          icon: "cil-building",
          showTo: ["super_admin"],
          show: hasPermission(),
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/companies/list",
              show: hasPermission(),
            },
            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/companies/add",
              show: hasPermission(),
            },
          ],
        },
        {
          _tag: "CSidebarNavDropdown",
          name: "Therapists",
          className: "font-weight-bold",

          icon: "cil-user-follow",
          showTo: ["super_admin", "company", "operation", "therapist"],
          show: is_lead || hasPermission(),
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/users/list",
              show:
                is_lead || hasPermission(permissions, ["therapist.list"], role),
            },
            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/users/add",
              show: hasPermission(permissions, ["therapist.add"], role),
            },
          ],
        },

        {
          _tag: "CSidebarNavDropdown",
          name: "Partners",
          className: "font-weight-bold",

          icon: "cil-user-follow",
          showTo: ["sales"],
          show: hasPermission(),
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/partners/list",
              show: hasPermission(),
            },
          ],
        },

        {
          _tag: "CSidebarNavDropdown",
          name: "Sales Team",
          className: "font-weight-bold",

          icon: "cil-user-follow",
          showTo: ["super_admin", "company"],
          show: hasPermission(),
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/sales/list",
              show: hasPermission(permissions, ["sales_team.list"], role),
            },
            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/sales/add",
              show: hasPermission(permissions, ["sales_team.add"], role),
            },
          ],
        },
        {
          _tag: "CSidebarNavDropdown",
          name: "Operations",
          className: "font-weight-bold",

          icon: "cil-user-follow",
          showTo: ["super_admin", "company"],
          show: hasPermission(),
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/operation/list",
              show: hasPermission(permissions, ["operation.list"], role),
            },
            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/operation/add",
              show: hasPermission(permissions, ["operation.add"], role),
            },
          ],
        },

        {
          _tag: "CSidebarNavDropdown",
          name: "Clients",
          className: "font-weight-bold",
          show: hasPermission(),
          icon: "cil-user",
          showTo: ["super_admin", "company", "operation"],
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/clients/list",
              show: hasPermission(permissions, ["client.list"], role),
            },

            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/clients/add",
              show: hasPermission(permissions, ["client.add"], role),
            },
          ],
        },
      ],
    },
    {
      _tag: "CSidebarNavDropdown",
      name: "User Management",
      className: "font-weight-bold",

      icon: "cil-user-follow",
      showTo: ["company", "operation"],
      _children: [
        {
          _tag: "CSidebarNavDropdown",
          name: "Therapists",
          className: "font-weight-bold",

          icon: "cil-user-follow",
          showTo: ["super_admin", "company", "operation"],
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/users/list",
              show: hasPermission(permissions, ["therapist.list"], role),
            },
            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/users/add",
              show: hasPermission(permissions, ["therapist.add"], role),
            },
          ],
        },
        {
          _tag: "CSidebarNavDropdown",
          name: "Partners",
          className: "font-weight-bold",

          icon: "cil-user-follow",
          showTo: ["super_admin", "company", "operation"],
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/partners/list",
              show: hasPermission(permissions, ["partner.list"], role),
            },
            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/partners/add",
              show: hasPermission(permissions, ["partner.add"], role),
            },
          ],
        },

        {
          _tag: "CSidebarNavDropdown",
          name: "Sales Team",
          className: "font-weight-bold",

          icon: "cil-user-follow",
          showTo: ["super_admin", "company"],
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/sales/list",
              show: hasPermission(permissions, ["sales_team.list"], role),
            },
            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/sales/add",
              show: hasPermission(permissions, ["sales_team.add"], role),
            },
          ],
        },
        {
          _tag: "CSidebarNavDropdown",
          name: "Operations",
          className: "font-weight-bold",

          icon: "cil-user-follow",
          showTo: ["super_admin", "company"],
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/operation/list",
              show: hasPermission(permissions, ["operation.list"], role),
            },
            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/operation/add",
              show: hasPermission(permissions, ["operation.add"], role),
            },
          ],
        },

        {
          _tag: "CSidebarNavDropdown",
          name: "Clients",
          className: "font-weight-bold",

          icon: "cil-user",
          showTo: ["super_admin", "company", "operation"],
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/clients/list",
              show: hasPermission(permissions, ["client.list"], role),
            },

            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/clients/add",
              show: hasPermission(permissions, ["client.add"], role),
            },
          ],
        },
      ],
    },

    {
      _tag: "CSidebarNavDropdown",
      name: "Partners",
      className: "font-weight-bold",

      icon: "cil-user-follow",
      showTo: ["sales"],
      _children: [
        {
          _tag: "CSidebarNavItem",
          name: "List",
          to: "/partners/list",
          show: hasPermission(),
        },
        {
          _tag: "CSidebarNavItem",
          name: "Add",
          to: "/partners/add",
          show: hasPermission(),
        },
      ],
    },

    {
      _tag: "CSidebarNavItem",
      name: "Therapists",
      className: "font-weight-bold",
      icon: "cil-user-follow",
      showTo: ["operation"],
      show: hasPermission(),
      to: "/users/list",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Therapists",
      className: "font-weight-bold",
      icon: "cil-user-follow",
      showTo: ["therapist"],
      show: is_lead,
      to: "/users/list",
    },

    {
      _tag: "CSidebarNavDropdown",
      name: "Catalogue & Pricing",
      className: "font-weight-bold",

      icon: "cil-list",
      showTo: ["super_admin", "company"],
      _children: [
        {
          _tag: "CSidebarNavDropdown",
          name: "Plans",
          className: "font-weight-bold",
          icon: "cil-list",
          showTo: ["super_admin", "company"],

          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/plans/list",
              show: hasPermission(permissions, ["plan.list"], role),
            },

            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/plans/add",
              show: hasPermission(permissions, ["plan.add"], role),
            },
          ],
        },
        {
          _tag: "CSidebarNavDropdown",
          name: "Discount",
          className: "font-weight-bold",

          icon: "cil-list",
          showTo: ["super_admin", "company"],
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/discountCoupons/list",
              show: hasPermission(permissions, ["discount.list"], role),
            },
            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/discountCoupons/add",
              show: hasPermission(permissions, ["discount.add"], role),
            },
          ],
        },
      ],
    },

    {
      _tag: "CSidebarNavDropdown",
      name: "Capacity Management",
      className: "font-weight-bold",

      icon: "cil-calendar",
      showTo: ["super_admin", "company", "operation"],
      _children: [
        {
          _tag: "CSidebarNavDropdown",
          name: "Slots",
          className: "font-weight-bold",

          icon: "cil-calendar",
          showTo: ["super_admin", "company", "operation"],

          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: `/Slots/list?startdate=${moment().format(
                "YYYY-MM-DD"
              )}&enddate=${moment().format("YYYY-MM-DD")}&first_load=true`,
              show: hasPermission(permissions, ["slot.list"], role),
            },
            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/Slots/Add",
              show: hasPermission(permissions, ["slot.add"], role),
            },
          ],
        },
        {
          _tag: "CSidebarNavItem",
          name: "Assessments",
          className: "font-weight-bold",
          to: `/allAppointments?startdate=${moment().format(
            "YYYY-MM-DD"
          )}&enddate=${moment().format("YYYY-MM-DD")}`,
          icon: "cil-book",
          showTo: ["super_admin", "company", "operation"],
          show: hasPermission(permissions, ["assessment.list"], role),
        },
        {
          _tag: "CSidebarNavItem",
          name: "Calendar View",
          to: "/calendar-view",
          icon: "cil-calendar",
          show: hasPermission(permissions, ["calendar_view"], role),
        },
        {
          _tag: "CSidebarNavItem",
          name: "Archived Slots",
          to: "/archived-slots/list",
          icon: "cil-calendar",
          show: hasPermission(),
        },
      ],
    },

    {
      _tag: "CSidebarNavDropdown",
      name: "Billing & Payment",
      className: "font-weight-bold",

      icon: "cil-money",
      showTo: ["super_admin", "company", "operation"],
      _children: [
        {
          _tag: "CSidebarNavItem",
          name: "Transactions",
          className: "font-weight-bold",
          to: `/transactions`,
          icon: "cil-money",
          showTo: ["super_admin", "company", "operation"],
          show: hasPermission(permissions, ["transaction"], role),
          hidden,
        },

        {
          _tag: "CSidebarNavDropdown",
          name: "Payments Link",
          className: "font-weight-bold",
          icon: "cil-money",
          showTo: ["super_admin", "company", "operation"],
          show: hasPermission(permissions, ["payment_link"], role),
          hidden,

          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/payments/links",
            },
            {
              _tag: "CSidebarNavItem",
              name: "Create",
              to: "/payments/createLink",
            },
          ],
        },

        {
          _tag: "CSidebarNavItem",
          name: "Invoices",
          className: "font-weight-bold",
          icon: "cil-money",
          showTo: ["super_admin", "company", "operation"],
          show: hasPermission(permissions, ["invoice.list"], role),
          to: "/invoices/list",
        },

        {
          _tag: "CSidebarNavItem",
          name: "Payment Approval",
          className: "font-weight-bold",
          icon: "cil-money",
          showTo: ["super_admin", "company", "operation"],
          show: hasPermission(permissions, ["payment_approval.list"], role),
          to: "/bankTransfer",
        },
      ],
    },

    {
      _tag: "CSidebarNavDropdown",
      name: "Curriculum",
      className: "font-weight-bold",

      icon: "cil-puzzle",
      showTo: ["therapist", "super_admin", "company"],
      _children: [
        {
          _tag: "CSidebarNavDropdown",
          name: "Master Activity",
          className: "font-weight-bold",
          icon: "cil-puzzle",
          showTo: ["therapist", "super_admin", "company"],
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/masterActivity/list",
              show: hasPermission(permissions, ["master_activity.list"], role),
            },
            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/masterActivity/add",
              show: hasPermission(permissions, ["master_activity.add"], role),
            },
          ],
        },
        {
          _tag: "CSidebarNavDropdown",
          name: "Master Questions",
          className: "font-weight-bold",
          icon: "cil-puzzle",
          showTo: ["therapist", "super_admin", "company"],
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/masterQuestions/list",
              show: hasPermission(permissions, ["master_question.list"], role),
            },
            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/masterQuestions/add",
              show: hasPermission(permissions, ["master_question.add"], role),
            },
          ],
        },

        {
          _tag: "CSidebarNavDropdown",
          name: "Master Goals",
          className: "font-weight-bold",
          icon: "cil-football",
          showTo: ["therapist", "super_admin", "company"],
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: "/masterGoal/list",
              show: hasPermission(permissions, ["master_goal.list"], role),
            },
            {
              _tag: "CSidebarNavItem",
              name: "Add",
              to: "/masterGoal/add",
              show: hasPermission(permissions, ["master_goal.add"], role),
            },
          ],
        },
        {
          _tag: "CSidebarNavItem",
          name: "Tutorials",
          className: "font-weight-bold",
          icon: "cil-video",
          showTo: ["therapist", "super_admin", "company"],
          to: "/tutorials",
          show: hasPermission(permissions, ["tutorial.list"], role),
        },
        {
          _tag: "CSidebarNavItem",
          name: "Master Videos",
          className: "font-weight-bold",
          icon: "cil-video",
          showTo: ["therapist", "super_admin", "company"],
          to: "/masterVideo",
          show: hasPermission(permissions, ["master_video.list"], role),
        },
        {
          _tag: "CSidebarNavItem",
          name: "Media Manager",
          className: "font-weight-bold",
          to: "/media-manager/list",
          icon: "cil-spreadsheet",
          showTo: ["super_admin", "company"],
          show: hasPermission(permissions, ["media_manager"], role),
        },
      ],
    },

    {
      _tag: "CSidebarNavDropdown",
      name: "Leads",
      className: "font-weight-bold",

      icon: "cil-user",
      showTo: ["super_admin", "company", "partner", "sales", "operation"],
      _children: [
        {
          _tag: "CSidebarNavItem",
          name: "List",
          to: "/leads/list",
          show: hasPermission(permissions, ["lead.list"], role),
        },
        {
          _tag: "CSidebarNavItem",
          name: "Add",
          to: "/leads/add",
          show: hasPermission(permissions, ["lead.add"], role),
        },
      ],
    },

    {
      _tag: "CSidebarNavItem",
      name: "Clients",
      className: "font-weight-bold",
      to: `/clients/list`,
      icon: "cil-user",
      showTo: ["therapist"],
      show: is_lead,
    },
    {
      _tag: "CSidebarNavItem",
      name: "My Clients",
      className: "font-weight-bold",
      to: `/my/clients/list`,
      icon: "cil-user",
      showTo: ["therapist"],
      show: hasPermission(),
    },

    // {
    //   _tag: "CSidebarNavDropdown",
    //   name: "My Clients",
    //   className: "font-weight-bold ml-2 mr-2",

    //   icon: "cil-user",
    //   showTo: ["therapist"],
    //   _children: [
    //     {
    //       _tag: "CSidebarNavItem",
    //       name: "List",
    //       to: `/my/clients/list`,
    //     },

    //     {
    //       _tag: "CSidebarNavItem",
    //       name: "Add",
    //       to: `/my/clients/add`,
    //     },
    //   ],
    // },

    {
      _tag: "CSidebarNavItem",
      name: "Calendar View",
      className: "font-weight-bold",
      icon: "cil-calendar",
      showTo: ["sales"],
      to: "/calendar-view",
      show: hasPermission(),
    },

    {
      _tag: "CSidebarNavItem",
      name: "View Plans",
      className: "font-weight-bold",
      to: "/plan/view",
      icon: "cil-user",
      showTo: ["sales", "operation"],
      show: hasPermission(),
    },
    {
      _tag: "CSidebarNavItem",
      name: "Discount",
      className: "font-weight-bold",
      icon: "cil-money",
      showTo: ["sales", "operation"],
      to: "/discountCoupons/list",
      show: hasPermission(),
    },
    {
      _tag: "CSidebarNavDropdown",
      name: is_lead ? "Slots" : "My Slots",
      className: "font-weight-bold",
      icon: "cil-calendar",
      showTo: ["therapist"],
      show: !is_lead,
      _children: [
        {
          _tag: "CSidebarNavItem",
          name: "List",
          to: `${
            is_lead ? "/slots/" : "/my/slots/"
          }list?startdate=${moment().format(
            "YYYY-MM-DD"
          )}&enddate=${moment().format("YYYY-MM-DD")}&first_load=true`,
          show: hasPermission(),
        },
        {
          _tag: "CSidebarNavItem",
          name: "Calendar View",
          to: "/calendar-view",
          show: hasPermission(),
        },
      ],
    },

    {
      _tag: "CSidebarNavItem",
      name: "Assessments",
      className: "font-weight-bold",
      to: `/my/appointments/list?startdate=${moment().format(
        "YYYY-MM-DD"
      )}&enddate=${moment().format("YYYY-MM-DD")}`,
      icon: "cil-book",
      showTo: ["therapist"],
      show: hasPermission(),
    },

    // {
    //   _tag: "CSidebarNavItem",
    //   name: "Games",
    //   className: "font-weight-bold ml-2 mr-2",
    //   to: "/games/movingCar",
    //   icon: "cil-gamepad",
    //   showTo: ["client"],
    // },
    // {
    //   _tag: "CSidebarNavItem",
    //   name: "Master Games",
    //   className: "font-weight-bold",
    //   to: "/master-games",
    //   icon: "cil-gamepad",
    //   showTo: ["therapist"],
    // },
    {
      _tag: "CSidebarNavItem",
      name: "My Goals",
      className: "font-weight-bold",
      to: `/my_goals/${store?.getState()?.auth?.userDetails?._id}`,
      icon: "cil-gamepad",
      showTo: ["client"],
      show: hasPermission(),
    },

    // {
    //   _tag: "CSidebarNavDropdown",
    //   name: "Add Tutorial",
    //   className: "font-weight-bold ml-2",
    //   icon: "cil-video",
    //   showTo: ["therapist", "super_admin", "company"],
    //   _children: [
    //     {
    //       _tag: "CSidebarNavItem",
    //       name: "Add",
    //       to: "/tutorials/add",
    //     },
    //     {
    //       _tag: "CSidebarNavItem",
    //       name: "List",
    //       to: "/tutorials/list",
    //     },
    //   ],
    // },

    {
      _tag: "CSidebarNavDropdown",
      name: "Reports",
      className: "font-weight-bold",

      icon: "cil-list",
      showTo: ["super_admin", "company"],
      _children: [
        {
          _tag: "CSidebarNavItem",
          name: "Weekly Session Report",
          className: "font-weight-bold",
          icon: "cib-read-the-docs",
          showTo: ["super_admin", "company"],
          to: "/weekly-session-report",
          show: hasPermission(permissions, ["weekly_session_report"], role),
        },
        {
          _tag: "CSidebarNavDropdown",
          name: "IEP",
          className: "font-weight-bold",

          icon: "cib-read-the-docs",
          showTo: ["super_admin", "company"],
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: `/client-reports/list`,
              show: hasPermission(
                permissions,
                ["Iep.add", "Iep.list", "iep.add", "iep.list"],
                role
              ),
            },
          ],
        },
        {
          _tag: "CSidebarNavDropdown",
          name: "Progress Reports",
          className: "font-weight-bold",

          icon: "cib-read-the-docs",
          showTo: ["super_admin", "company"],
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: `/progress-reports/list`,
              show: hasPermission(permissions, ["progress_report.list"], role),
            },
          ],
        },
        {
          _tag: "CSidebarNavDropdown",
          name: "Screening Report",
          className: "font-weight-bold",

          icon: "cib-read-the-docs",
          showTo: ["super_admin", "company"],
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: `/assessment-reports/list`,
              show: hasPermission(
                permissions,
                ["evaluation_report.list"],
                role
              ),
            },
          ],
        },
        {
          _tag: "CSidebarNavDropdown",
          name: "Assessment Report",
          className: "font-weight-bold",

          icon: "cib-read-the-docs",
          showTo: ["super_admin", "company"],
          _children: [
            {
              _tag: "CSidebarNavItem",
              name: "List",
              to: `/demo-assessment-sheet/list`,
              show: hasPermission(permissions, ["demo_assessment.list"], role),
            },
          ],
        },
        {
          _tag: "CSidebarNavItem",
          name: "Screening Tests",
          className: "font-weight-bold",
          icon: "cil-video",
          showTo: ["super_admin", "company"],
          to: "/screening-tests",
          show: hasPermission(permissions, ["screening_test.list"], role),
          hidden,
        },
        {
          _tag: "CSidebarNavItem",
          name: "Download",
          className: "font-weight-bold",
          icon: "cil-cloud-download",
          showTo: ["super_admin", "company"],
          to: "/allAppointmentDetails",
          show: hasPermission(permissions, ["download"], role),
        },
      ],
    },

    {
      _tag: "CSidebarNavItem",
      name: "Demo - Goals",
      className: "font-weight-bold",
      icon: "cil-video",
      showTo: ["super_admin", "company"],
      to: "/demogoals/add",
      show: hasPermission(permissions, ["demo_goal"], role),
      hidden,
    },
    {
      _tag: "CSidebarNavItem",
      name: "Demo Goals Requests",
      className: "font-weight-bold",
      to: `/demoGoalsRequests`,
      icon: "cil-list",
      showTo: ["super_admin", "company"],
      show: hasPermission(permissions, ["demo_goal_request"], role),
      hidden,
    },

    {
      _tag: "CSidebarNavDropdown",
      name: "Goals Screening",
      className: "font-weight-bold",

      icon: "cil-list",
      showTo: ["super_admin", "company"],

      _children: [
        {
          _tag: "CSidebarNavItem",
          name: "View Responses",
          to: "/goals-screening-list",
          icon: "cil-list",
          show: hasPermission(permissions, ["goals_screening"], role),
        },
        {
          _tag: "CSidebarNavItem",
          name: "View Generated Links",
          to: "/generated-screening-links",
          icon: "cil-list",
          show: hasPermission(permissions, ["goals_screening"], role),
        },
      ],
    },
    {
      _tag: "CSidebarNavItem",
      name: "Logs",
      className: "font-weight-bold",
      to: `/logs/list`,
      icon: "cil-list",
      showTo: ["super_admin"],
      show: hasPermission(),
    },
    {
      _tag: "CSidebarNavItem",
      name: "Meeting Start Logs",
      className: "font-weight-bold",
      to: `/meeting-logs/list`,
      icon: "cil-list",
      showTo: ["super_admin"],
      show: hasPermission(),
    },
    {
      _tag: "CSidebarNavDropdown",
      name: "Client Documents",
      className: "font-weight-bold",

      icon: "cib-read-the-docs",
      showTo: ["super_admin", "company", "therapist"],
      _children: [
        {
          _tag: "CSidebarNavItem",
          name: "List",
          to: "/client-documents/list",
          show: hasPermission(permissions, ["client_document.list"], role),
        },
        {
          _tag: "CSidebarNavItem",
          name: "Add",
          to: "/client-documents/add",
          show: hasPermission(permissions, ["client_document.add"], role),
        },
      ],
    },
    {
      _tag: "CSidebarNavDropdown",
      name: "IEP",
      className: "font-weight-bold",
      icon: "cil-list",
      showTo: ["therapist"],
      _children: [
        {
          _tag: "CSidebarNavItem",
          name: "List",
          className: "font-weight-bold",
          to: `/client-reports/list`,
          show: hasPermission(),
        },
        {
          _tag: "CSidebarNavItem",
          name: "Add",
          className: "font-weight-bold",
          to: "/client-reports/add",
          show: hasPermission(),
        },
      ],
    },
    {
      _tag: "CSidebarNavDropdown",
      name: "Progress Reports",
      className: "font-weight-bold",
      icon: "cil-list",
      showTo: ["therapist"],
      _children: [
        {
          _tag: "CSidebarNavItem",
          name: "List",
          className: "font-weight-bold",
          to: `/progress-reports/list`,
          show: hasPermission(),
        },
        {
          _tag: "CSidebarNavItem",
          name: "Add",
          className: "font-weight-bold",
          to: "/progress-reports/add",
          show: hasPermission(),
        },
      ],
    },
    {
      _tag: "CSidebarNavDropdown",
      name: "Evaluation Reports",
      className: "font-weight-bold",
      icon: "cil-list",
      showTo: ["therapist"],
      _children: [
        {
          _tag: "CSidebarNavItem",
          name: "List",
          className: "font-weight-bold",
          to: `/assessment-reports/list`,
          show: hasPermission(),
        },
        {
          _tag: "CSidebarNavItem",
          name: "Add",
          className: "font-weight-bold",
          to: "/assessment-reports/add",
          show: hasPermission(),
        },
      ],
    },
    {
      _tag: "CSidebarNavDropdown",
      name: "Assessment Report",
      className: "font-weight-bold",
      icon: "cil-list",
      showTo: ["therapist"],
      _children: [
        {
          _tag: "CSidebarNavItem",
          name: "List",
          className: "font-weight-bold",
          to: `/demo-assessment-sheet/list`,
          show: hasPermission(),
        },
        {
          _tag: "CSidebarNavItem",
          name: "Add",
          className: "font-weight-bold",
          to: "/demo-assessment-sheet/add",
          show: hasPermission(),
        },
      ],
    },
    {
      _tag: "CSidebarNavItem",
      name: "Create Offer",
      className: "font-weight-bold",
      to: `/create-offer`,
      icon: "cil-list",
      showTo: ["super_admin", "sales", "company"],
      show: hasPermission(permissions, ["create_offer"], role),
    },
  ];
};

export default _nav;
